<template>
	<div>
		<div v-if="error" class="fadeIn error-message"><span>{{errorMessage}}</span></div>
		<div class="form-group">
			<label class="col-3" for="Name">Name</label>
			<input class="col-8" type="text" id="Name" name="Name" v-model="user.name">
		</div>
		<div class="form-group">
			<label class="col-3" for="username">Username</label>
			<input class="col-8" type="text" id="username" name="username" v-model="user.username">
		</div>
		<div class="form-group">
			<label class="col-3" for="email">Email</label>
			<input class="col-8" type="text" id="email" name="email" v-model="user.email">
		</div>
		<div class="form-group">
			<label class="col-3" for="about">About</label>
			<input class="col-8" type="text" id="about" name="about" v-model="user.about">
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ProfileEditWidget',
		props: {
			user: Object
		},
		data(){
			return {
				updating:{
					'name':String,
					'username':String,
					'email':String,
					'about':String
				},
				errorMessage: "",
				error: false
			}
		},
		mounted(){
			this.$parent.$parent.onOk=this.updateProfile;
		},
		methods:{
			updateProfile: async function(){
				let response = await this.$API.apiPATCH("/profile", this.updating, true);
				if (response.status=="fail") {
					this.errorMessage=response.message;
        			this.error=true;
				} else {
					this.$parent.$parent.hide();}
			}
		},
		watch:{
		    'user.name':function(val){
		      this.updating.name=val;
		    },
		    'user.username':function(val){
		      this.updating.username=val;
		    },
		    'user.email':function(val){
		      this.updating.email=val;
		    },
		    'user.about':function(val){
		      this.updating.about=val;
		    }
		}
	}
</script>